export class DisplayOptions {
  useConcreteTime = false;
}
